import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const userRole = localStorage.getItem('userRole');

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  // Check if user is admin (userRole === '1')
  if (userRole !== '1') {
    return <Navigate to="/home" />;
  }

  return <Outlet />;
};

export default AdminRoute; 